import { put } from '@client/lib/request';

export function cancelPreliminarySession(id) {
    return put('/mylounge-api/checkout/cancel-preliminary-session', { id });
}
